// extracted by mini-css-extract-plugin
export default {"ctaContainer":"Community_ctaContainer__JPjdP","textContent":"Community_textContent__Iv3A5","ctaButton":"Community_ctaButton__xOYdz"};